// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__bS_x5","image--not-clicked":"styles_image--not-clicked__B1AAR","skeleton-animation":"styles_skeleton-animation__IBDhd"};